import { put, takeLatest } from 'redux-saga/effects';
import { createPanelApiSaga } from '@/features/auth/store/panel-api-saga';
import * as adminApi from '../api/admin.api';
import {
  decideModeration,
  decideOrganizationVerification,
  fetchAdminUsers,
  fetchOverview,
  fetchQueue,
  fetchQueueItem,
  fetchVerificationDocument,
  fetchVerificationQueue,
  runSignals,
  suspendUser,
  unsuspendUser,
} from './admin.slice';

const apiSaga = createPanelApiSaga();

/**
 * Admin sagaları (Epic 11). Önbellek invalidation ELLE ve AÇIK:
 * `INVALIDATION_MAP` `admin/*` anahtarlarına göre mutasyon sonrası KPI'lar
 * (`fetchOverview`) burada tazelenir; kullanıcı satırı/kuyruk kalemi slice
 * içinde yerinde güncellendiği için listeler yeniden çekilmez.
 */
export function* adminSaga() {
  yield takeLatest(
    fetchAdminUsers.request.type,
    apiSaga(fetchAdminUsers, adminApi.fetchAdminUsers),
  );

  yield takeLatest(
    suspendUser.request.type,
    apiSaga(
      suspendUser,
      async (arg) => {
        await adminApi.suspendUser(arg.userId, arg.reason);
        return { userId: arg.userId };
      },
      {
        // INVALIDATION_MAP 'admin/suspendUser': adminUserList (yerinde) + adminOverview.
        onSuccess: function* () {
          yield put(fetchOverview.request());
        },
      },
    ),
  );

  yield takeLatest(
    unsuspendUser.request.type,
    apiSaga(
      unsuspendUser,
      async (arg) => {
        await adminApi.unsuspendUser(arg.userId, arg.reason);
        return { userId: arg.userId };
      },
      {
        onSuccess: function* () {
          yield put(fetchOverview.request());
        },
      },
    ),
  );

  yield takeLatest(fetchQueue.request.type, apiSaga(fetchQueue, adminApi.fetchModerationQueue));
  yield takeLatest(
    fetchQueueItem.request.type,
    apiSaga(fetchQueueItem, adminApi.fetchModerationItem),
  );

  yield takeLatest(
    decideModeration.request.type,
    apiSaga(decideModeration, (arg) => adminApi.decideModeration(arg.itemId, arg.input), {
      // INVALIDATION_MAP 'admin/decideModeration': kuyruk kalemi yerinde
      // güncellenir; KPI'lar yeniden çekilir.
      onSuccess: function* () {
        yield put(fetchOverview.request());
      },
    }),
  );

  yield takeLatest(
    runSignals.request.type,
    apiSaga(runSignals, adminApi.runSignals, {
      // INVALIDATION_MAP 'admin/runSignals': kuyruk + KPI tazelenir.
      onSuccess: function* () {
        yield put(fetchQueue.request({ status: 'open', page: 1, pageSize: 50 }));
        yield put(fetchOverview.request());
      },
    }),
  );

  yield takeLatest(fetchOverview.request.type, apiSaga(fetchOverview, adminApi.fetchAdminOverview));

  /*
   * Kurum doğrulama kuyruğu (Story 18.4). INVALIDATION_MAP
   * 'admin/decideOrganizationVerification': karara bağlanan satır slice'ta
   * yerinde düşürülür, kuyruk yine de sunucudan tazelenir (ikinci bir admin
   * aynı anda karar vermiş olabilir).
   */
  yield takeLatest(
    fetchVerificationQueue.request.type,
    apiSaga(fetchVerificationQueue, adminApi.fetchVerificationQueue),
  );
  // Bileşen API'ye DOKUNMAZ: imzalı belge bağlantısı da saga üzerinden gelir.
  yield takeLatest(
    fetchVerificationDocument.request.type,
    apiSaga(fetchVerificationDocument, adminApi.fetchVerificationDocumentUrl),
  );
  yield takeLatest(
    decideOrganizationVerification.request.type,
    apiSaga(
      decideOrganizationVerification,
      (arg) => adminApi.decideVerification(arg.requestId, arg.input),
      {
        onSuccess: function* () {
          yield put(fetchVerificationQueue.request({ status: 'open', page: 1, pageSize: 50 }));
        },
      },
    ),
  );
}
